import type { IData } from '../model/IData'
import { averageRounded } from './averageRounded'
import { expectDefined } from './expectDefined'
import { getAge } from './getAge'
import { getCouples } from './getCouples'

let valueMale: number | undefined
let valueFemale: number | undefined

export function getAverageFirstMarriageAge(data: IData, isMale: boolean) {
	let value = isMale ? valueMale : valueFemale
	if (value == null) {
		const values: number[] = []
		for (const person of Object.values(data.personsById)) {
			if (!person.isMale === !isMale && person.birthDate) {
				const couples = getCouples(data, person.id)
				if (couples.length && !couples.find((it) => !it.marriedDate)) {
					const couple = couples.at(0)!
					values.push(
						expectDefined(getAge(person.birthDate, couple.marriedDate)),
					)
				}
			}
		}
		value = averageRounded(values)
		if (isMale) {
			valueMale = value
		} else {
			valueFemale = value
		}
	}
	return value
}
